var map = {
	"./authenticatorQR.png": 2,
	"./biometric.svg": 3,
	"./email.svg": 4,
	"./passkey-logo-orange.svg": 5,
	"./phone-number.svg": 6,
	"./security-face.svg": 7,
	"./unplug.svg": 8
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;